import React, { Suspense } from "react";
import ReactDOM from 'react-dom/client';
import { HashRouter } from "react-router-dom";

import './index.css';
import App from "./components/App";
import reportWebVitals from './reportWebVitals';

import "./i18next";
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <HashRouter >
    <Suspense fallback="loading">
      <App />
    </Suspense>
  </HashRouter>
);
reportWebVitals();
